import PropTypes from 'prop-types'
import { css } from 'styled-components'

const flexItemMixin = css`
  flex-grow: ${({ grow }) => grow ?? 0};
  flex-basis: ${({ basis }) => basis || 'auto'};
  flex-shrink: ${({ shrink }) => shrink ?? 1};
  ${({ flex }) => (typeof flex !== 'undefined' ? `flex: ${flex}` : null)};
`
const flexItemPropTypes = {
  grow: PropTypes.number,
  shrink: PropTypes.number,
  basis: PropTypes.string,
  flex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export { flexItemPropTypes, flexItemMixin }
